<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <div>
            <h1 class="title-view">
              Coverage Area
            </h1>

            <div class="box-id">
              <h2 class="number-id">
                {{ areaCode }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              class="min-button ml-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view' && canUserUpdate"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb ml-2"
              @click="saveArea()"
              v-if="mode === 'edit' && canUserUpdate"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card">
            <div class="row mb-2">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 ">
                <div class="data-block">
                  <span class="title-block">Destination / Supplier</span>
                  <span class="content-block"
                    >{{ branchName }} - {{ operatorName }}</span
                  >
                </div>
              </div>

              <div
                class="col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12"
                v-if="mode === 'view'"
              >
                <div class="data-block">
                  <span class="title-block">Description</span>
                  <span class="content-block">{{
                    serviceArea.description
                  }}</span>
                </div>
              </div>

              <div
                class="col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 align-self-center"
                v-if="mode === 'edit'"
                v-bind:class="{
                  'is-invalid': $v.serviceArea.description.$error
                }"
              >
                <label
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.serviceArea.description.$error
                  }"
                  ><span class="markrequired">*</span>Description
                </label>
                <el-input
                  v-model="$v.serviceArea.description.$model"
                  placeholder="Description"
                  id="description"
                  name="description"
                  tabindex="2"
                  maxlength="160"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 5 }"
                  show-word-limit
                >
                </el-input>
                <div
                  v-if="$v.serviceArea.description.$error"
                  class="invalid-feedback mt--1"
                >
                  {{
                    !$v.serviceArea.description.minLength ||
                    $v.serviceArea.description.$error
                      ? `Enter ${$v.serviceArea.description.$params.minLength.min} to ${$v.serviceArea.description.$params.maxLength.max} characters.`
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card pb-4">
            <base-input
              id="autocomplete"
              label="Search Location"
              placeholder="Enter Location"
              v-model="search"
              class="abso-map-1"
              v-if="mode === 'edit'"
            />
            <base-button
              v-if="mode === 'edit'"
              type=""
              class="min-button btn-line-danger abso-map-3"
              @click="resetPolygonPaths"
            >
              <i class="flaticon-eraser"></i> Reset Area
            </base-button>

            <GoogleMaps
              :paths="coordinates"
              :resetPaths="resetPaths"
              :autoCompleteElementId="'autocomplete'"
              :allowPolygonDraw="mode === 'edit'"
              @updateCoordinates="onUpdateCoordinates"
            />
          </div>
        </div>
      </div>
      <div class="alinmov2 mb-4" v-if="mode === 'edit' && canUserUpdate">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button type="primary" class="min-button mb-0" @click="saveArea()">
          <i class="flaticon-floppy-disk"></i>Save Area
        </base-button>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import GoogleMaps from "@/components/GoogleMap";
import { AreasAPI, BranchesAPI } from "../../../core/api";
import lodash from "lodash";
import WSelect from "@/components/Select";
import {
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Checkbox,
  Switch,
  Card
} from "element-ui";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Area",
  data() {
    return {
      branchesOptionsByOperatorId: [],
      serviceArea: {
        description: "",
        supplier: "",
        branch: "",
        polygon: [],
        relationship: {
          owner: null,
          type: "admin"
        }
      },
      minimumSelect: [2, 4, 6, 8, 10],
      tempCoordinates: [],
      coordinates: [],
      resetPaths: false,
      search: null,
      area: false,
      serviceAreaCopy: {},
      saved: false,
      areaId: "",
      destinationsOptions: [],
      destinations: [],
      areaCode: "",
      branchName: "Unknown",
      operatorName: "Unknown",
      mode: "view"
    };
  },
  watch: {},
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Coverage Areas",
        to: "/coverage-areas"
      },

      {
        text: "Area Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.areaId = this.$route.params.id;
    await this.getOneArea(this.areaId);
    this.destinationsOptions = this.sortByDestinationName(
      await this.getDestinations()
    );
    this.destinations = this.destinationsOptions;
  },
  methods: {
    async getOneArea(areaId) {
      try {
        this.setLoad(true);
        let { data } = await AreasAPI.getAreaById(areaId, this.sesion.token);
        this.setLoad(false);
        if (data.status) {
          let area = data.data;
          this.serviceArea.supplier = area.supplier._id;
          this.serviceArea.branch = area.branch._id;
          this.serviceArea.description = area.description;
          this.serviceArea.polygon = this.parseCoordinates(area.polygon);
          this.coordinates = this.serviceArea.polygon;
          this.serviceArea.relationship.owner = area.relationship.owner;
          this.serviceArea.relationship.type = area.relationship.type;

          this.areaCode = area.code;
          this.branchName = area.branch.name;
          this.operatorName = area.supplier.businessDetails.name;

          this.serviceAreaCopy = lodash.cloneDeep(this.serviceArea);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async saveArea(router = null) {
      if (!this.$v.serviceArea.$invalid) {
        await this.updateArea(this.areaId, this.serviceArea, router);
      } else {
        this.$v.serviceArea.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateArea(areaId, area, router) {
      try {
        this.setLoad(true);
        let { data } = await AreasAPI.updateAreaById(
          areaId,
          area,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Area has been Updated",
            icon: "flaticon-check-3"
          });
          if (router) {
            this.$router.push(router);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Coverage Area, please try again"
        );
      }
    },
    async resetPolygonPaths() {
      let { value } = await Swal.fire({
        title: "Reset Coverage Areas",
        text: "Are you sure do you want to reset this Coverage Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.resetPaths = true;
      }
    },
    onUpdateCoordinates(coordinates) {
      this.tempCoordinates = coordinates;
      if (this.tempCoordinates.length === 0) {
        this.resetPaths = false;
      }
      this.serviceArea.polygon = this.tempCoordinates;
    },
    parseCoordinates(coordinates) {
      return coordinates.map(function(element) {
        return { lat: element.lat, lng: element.lng };
      });
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    isInAreaModule(modules = []) {
      if (!(modules.indexOf("areas") > -1)) {
        this.setAreaSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChange(to, from, next) {
      let isEqual = lodash.isEqual(this.serviceArea, this.serviceAreaCopy);
      if (!isEqual && !this.saved && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Coverage Areas has been modified, <br> do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveArea(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    selectDestination(destinationId) {
      let destination = this.destinationsOptions.find(
        destination => destination._id === destinationId
      );
      if (destination) {
        this.serviceArea.supplier = destination.supplier._id;
      }
    },
    async getDestinations() {
      try {
        let { data } = await BranchesAPI.getBranchesOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    filterBranch(regx) {
      if (regx.length > 2) {
        this.destinations = this.destinationsOptions.filter(branch => {
          return (
            branch.name.toLowerCase().indexOf(regx.toLowerCase()) > -1 ||
            branch.supplier.businessDetails.name
              .toLowerCase()
              .indexOf(regx.toLowerCase()) > -1
          );
        });
      } else {
        this.destinations = this.destinationsOptions;
      }
    },
    sortByDestinationName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.name.toUpperCase();
        const secondCity = b.name.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setAreaSearchCriteria"
    ])
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Card.name]: Card,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    GoogleMaps,
    WSelect
  },
  computed: {
    ...mapGetters(["sesion", "userRole", "sigout"]),
    canUserUpdate() {
      return isUserAuthorized("AREAS", this.userRole, "UPDATE");
    }
  },
  validations: {
    serviceArea: {
      description: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(160)
      },
      supplier: {
        required
      },
      branch: {
        required
      },
      polygon: {
        $each: {
          lat: {},
          lng: {}
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInAreaModule(to.meta.modules);
    if (!this.sigout) {
      this.detectChange(to, from, next);
    } else {
      next();
    }
  }
};
</script>
